import { Link, useRouterState } from '@tanstack/react-router'
import { Icon } from '@/components/icons'
import { cn } from '@/lib/utils'

const NAV = [
  { to: '/liff', label: 'หน้าหลัก', icon: 'lucide:home' },
  { to: '/liff/outstanding', label: 'ค้างชำระ', icon: 'mdi:file-clock-outline' },
  { to: '/liff/wage', label: 'ค่าจ้าง', icon: 'mdi:cash-plus' },
  { to: '/liff/expense', label: 'ค่าใช้จ่าย', icon: 'mdi:receipt-text-outline' },
] as const

export function LiffShell({
  title,
  children,
  hideNav,
}: {
  title?: string
  children: React.ReactNode
  hideNav?: boolean
}) {
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  return (
    <div className="flex min-h-dvh flex-col bg-gradient-to-b from-slate-50 to-slate-100 text-foreground">
      <header className="sticky top-0 z-10 border-b border-border/50 bg-white/90 px-4 py-4 backdrop-blur-md">
        <h1 className="text-center text-xl font-bold tracking-tight text-slate-800">
          {title ?? 'OP5 บันทึกรายการ'}
        </h1>
      </header>

      <main className="app-content-scale flex-1 px-4 py-5 pb-28">{children}</main>

      {!hideNav ? (
        <nav className="fixed bottom-0 left-0 right-0 z-10 border-t border-border/60 bg-white/95 px-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 shadow-[0_-4px_24px_rgba(0,0,0,0.06)]">
          <ul className="mx-auto flex max-w-lg items-stretch justify-around gap-1">
            {NAV.map((item) => {
              const active =
                item.to === '/liff'
                  ? pathname === '/liff' || pathname === '/liff/'
                  : item.to === '/liff/outstanding'
                    ? pathname.startsWith('/liff/outstanding')
                    : pathname.startsWith(item.to)
              return (
                <li key={item.to} className="flex-1">
                  <Link
                    to={item.to}
                    className={cn(
                      'flex min-h-[56px] flex-col items-center justify-center gap-1 rounded-xl px-2 py-2 text-xs font-medium transition-colors',
                      active
                        ? 'bg-slate-800 text-white'
                        : 'text-slate-600 hover:bg-slate-100',
                    )}
                  >
                    <Icon icon={item.icon} className="size-6" aria-hidden />
                    <span>{item.label}</span>
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
      ) : null}
    </div>
  )
}
